import { api } from './client'

export interface Task {
  id: string
  title: string
  description: string | null
  assigneeUserId: string | null
  contactId: string | null
  dealId: string | null
  dueAt: string | null
  completedAt: string | null
  status: string
  source: string
  escalationLevel: number
  createdAt: string
  dealTitle: string | null
  contactName: string | null
}

export interface CreateTaskParams {
  title: string
  description?: string | null
  /** The deal it's about (assigned to the deal's owner by default). */
  dealId?: string | null
  /** A task about a person, no deal ("call Sarah back"); ignored when dealId is set. */
  contactId?: string | null
  /** Who does it; default = the deal's owner, else you. */
  assigneeUserId?: string | null
  /** ISO-8601 instant, e.g. 2026-07-10T00:00:00Z. */
  dueDate?: string | null
  /** The picked calendar day (YYYY-MM-DD) — drives the linked deal's next contact date. */
  dueDateLocal?: string | null
}

/** Manual task (on a deal, a contact, or standalone) — POST /api/tasks → 201. */
export async function createTask(params: CreateTaskParams): Promise<Task> {
  const { data } = await api.post<Task>('/api/tasks', params)
  return data
}

export async function listTasks(status: 'open' | 'done' = 'open'): Promise<Task[]> {
  const { data } = await api.get<Task[]>('/api/tasks', { params: { status } })
  return data
}

export async function listContactTasks(contactId: string): Promise<Task[]> {
  const { data } = await api.get<Task[]>('/api/tasks', { params: { contactId } })
  return data
}

export async function listDealTasks(dealId: string): Promise<Task[]> {
  const { data } = await api.get<Task[]>('/api/tasks', { params: { dealId } })
  return data
}

export async function completeTask(id: string): Promise<Task> {
  const { data } = await api.post<Task>(`/api/tasks/${id}/complete`)
  return data
}

/** DELETE /api/tasks/{id} → 204. */
export async function deleteTask(id: string): Promise<void> {
  await api.delete(`/api/tasks/${id}`)
}

export async function runFollowUp(): Promise<{ created: number }> {
  const { data } = await api.post<{ created: number }>('/api/tasks/run-followup')
  return data
}
